
function IconExport({ iconPath, altText = 'icon', width = "45px", height = 35 }) {
    return <img src={iconPath} alt={altText} style={{ maxWidth: width, height: height, objectFit: "contain"  }} />;
}

export default IconExport;